import { ImagingCategoryEnum, MessageAttachment, MessageContentAttachmentMediaTypeEnum } from '@ffd/api-client';
import { FullSeriesVM, ImagingGalleryItem } from '@libs/imaging';

export interface CollaborationImageSelectorDialogData {
  siteId: string;
  patientId: string;
  isPatientCollab?: boolean;
  selectedImages?: ImagingGalleryItem[];
}

export enum GalleryItemCategory {
  PhotosAndVideos = 'photos_and_videos',
  Bitewings = 'bitewings',
  Periapicals = 'periapicals',
  Panoramics = 'pano',
  Scans = 'scans',
}

export enum GalleryItemTabs {
  FullSeries = 'full_series',
  PhotosAndVideos = 'photos_and_videos',
  Scans = 'scans',
}

export function isGalleryItemTab(value: ImagingCategoryEnum): value is ImagingCategoryEnumWithoutFullSeries {
  return Object.keys(ImagingCategoryEnumToGalleryItemTabs).includes(value);
}

export type CollaborationCategorizedPatientImages = {
  [key in GalleryItemTabs]: key extends GalleryItemTabs.FullSeries ? FullSeriesVM : ImagingGalleryItem[];
};

export type ImagingCategoryEnumWithoutFullSeries = Exclude<
  ImagingCategoryEnum,
  ImagingCategoryEnum.PERIAPICALS | ImagingCategoryEnum.BITEWINGS | ImagingCategoryEnum.PANORAMICS
>;

export const ImagingCategoryEnumToGalleryItemTabs: Record<
  Exclude<ImagingCategoryEnum, ImagingCategoryEnum.PERIAPICALS | ImagingCategoryEnum.BITEWINGS | ImagingCategoryEnum.PANORAMICS>,
  Exclude<GalleryItemTabs, GalleryItemTabs.FullSeries>
> = {
  [ImagingCategoryEnum.PHOTOS_AND_VIDEOS]: GalleryItemTabs.PhotosAndVideos,
  [ImagingCategoryEnum._3D]: GalleryItemTabs.Scans,
  [ImagingCategoryEnum.CT]: GalleryItemTabs.Scans,
};

export const ImagingButtonGroupRecord: Record<GalleryItemTabs, GalleryItemTabs> = {
  [GalleryItemTabs.FullSeries]: GalleryItemTabs.FullSeries,
  [GalleryItemTabs.PhotosAndVideos]: GalleryItemTabs.PhotosAndVideos,
  [GalleryItemTabs.Scans]: GalleryItemTabs.Scans,
};

export interface AddedGalleryItem {
  id: string;
  index: number;
  mediaType: MessageContentAttachmentMediaTypeEnum;
  type: ImagingCategoryEnum;
  groupImageId?: string;
  name?: string;
  date?: string;
}

export interface CollaborationImageSelectorDialogResult {
  attachments: MessageAttachment[];
}
